(function () {
  'use strict';

  // The English property key prefix CPB sends. Used only to detect & strip.
  var CPB_PREFIX = 'Customize your Hobby Horse - ';

  function getDict() {
    var all = window.HH_CPB_TRANSLATIONS || {};
    var locale = window.HH_CPB_LOCALE || 'en';
    return all[locale] || all['en'] || null;
  }

  // Strip price modifier like " (22)" or " (12.5)" from end of value
  function stripPriceMod(s) {
    return String(s).replace(/\s*\([\d.,]+\)\s*$/, '').trim();
  }

  // Is this a customization property we want to keep & translate?
  // True only for keys like "Customize your Hobby Horse - Size".
  // Everything else (_configId, View - Front, SKU, weight, _image, etc.) gets dropped.
  function isCpbCustomization(key) {
    return typeof key === 'string' && key.indexOf(CPB_PREFIX) === 0;
  }

  // Translate a CPB key: "Customize your Hobby Horse - Size" -> "Grösse"
  function translateKey(key, dict) {
    var category = key.slice(CPB_PREFIX.length).trim();
    return (dict.categories && dict.categories[category]) || category;
  }

  // Translate a value, stripping price modifier first
  function translateValue(value, dict) {
    var clean = stripPriceMod(value);
    return (dict.values && dict.values[clean]) || clean;
  }

  // Rewrite a properties object: drop technical props, translate customization props
  function cleanProperties(properties, dict) {
    if (!properties || typeof properties !== 'object') return properties;
    var out = {};
    Object.keys(properties).forEach(function (key) {
      if (isCpbCustomization(key)) {
        var newKey = translateKey(key, dict);
        var newValue = translateValue(properties[key], dict);
        out[newKey] = newValue;
      }
      // Everything else is dropped on the floor.
    });
    return out;
  }

  // Detect whether this payload is for "Build your horse"
  // (any property with the CPB prefix is a reliable signal)
  function isCpbPayload(payload) {
    if (!payload) return false;
    var items = payload.items || [payload];
    return items.some(function (item) {
      var props = item && item.properties;
      if (!props) return false;
      return Object.keys(props).some(isCpbCustomization);
    });
  }

  function rewriteBody(body) {
    var dict = getDict();
    if (!dict) return body;
    if (body && Array.isArray(body.items)) {
      body.items = body.items.map(function (item) {
        if (item.properties) item.properties = cleanProperties(item.properties, dict);
        return item;
      });
    } else if (body && body.properties) {
      body.properties = cleanProperties(body.properties, dict);
    }
    return body;
  }

  // --- fetch() intercept ---
  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    try {
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      if (url && /\/cart\/add(\.js)?(\?|$)/.test(url) && init && init.body) {
        var ct = '';
        if (init.headers) {
          if (init.headers instanceof Headers) {
            ct = init.headers.get('Content-Type') || '';
          } else if (typeof init.headers === 'object') {
            ct = init.headers['Content-Type'] || init.headers['content-type'] || '';
          }
        }
        if (ct.indexOf('application/json') !== -1 && typeof init.body === 'string') {
          try {
            var parsed = JSON.parse(init.body);
            if (isCpbPayload(parsed)) {
              parsed = rewriteBody(parsed);
              init.body = JSON.stringify(parsed);
            }
          } catch (e) { /* leave body as-is */ }
        } else if (typeof init.body === 'string' && init.body.indexOf('properties') !== -1) {
          // Form-encoded fallback
          try {
            var params = new URLSearchParams(init.body);
            var dict = getDict();
            if (!dict) throw new Error('no dict');
            // First check if this payload has any CPB keys at all
            var hasCpb = false;
            params.forEach(function (val, key) {
              var m = key.match(/^properties\[(.+)\]$/);
              if (m && isCpbCustomization(m[1])) hasCpb = true;
            });
            if (hasCpb) {
              var newParams = new URLSearchParams();
              params.forEach(function (val, key) {
                var m = key.match(/^properties\[(.+)\]$/);
                if (m) {
                  if (isCpbCustomization(m[1])) {
                    var newKey = translateKey(m[1], dict);
                    var newVal = translateValue(val, dict);
                    newParams.append('properties[' + newKey + ']', newVal);
                  }
                  // else: drop technical property
                } else {
                  newParams.append(key, val);
                }
              });
              init.body = newParams.toString();
            }
          } catch (e) { /* leave as-is */ }
        }
      }
    } catch (e) { /* never break the cart */ }
    return originalFetch.apply(this, [input, init]);
  };

  // --- XHR intercept (for jQuery.ajax / legacy code paths) ---
  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;
  var origSetHeader = XMLHttpRequest.prototype.setRequestHeader;

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__hh_url = url;
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.setRequestHeader = function (name, value) {
    if (name && name.toLowerCase() === 'content-type') this.__hh_ct = value;
    return origSetHeader.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    try {
      if (this.__hh_url && /\/cart\/add(\.js)?(\?|$)/.test(this.__hh_url) && body) {
        var ct = this.__hh_ct || '';
        if (ct.indexOf('application/json') !== -1 && typeof body === 'string') {
          var parsed = JSON.parse(body);
          if (isCpbPayload(parsed)) {
            parsed = rewriteBody(parsed);
            arguments[0] = JSON.stringify(parsed);
          }
        }
      }
    } catch (e) { /* never break the cart */ }
    return origSend.apply(this, arguments);
  };

  // Helper for Layer 1 — translates the product title if it's still "Build your horse"
  window.HHCart = {
    translateTitle: function (title) {
      if (title !== 'Build your horse') return title;
      var dict = getDict();
      return (dict && dict.title) || title;
    }
  };
})();